import { render, staticRenderFns } from "./TradingCompetition.vue?vue&type=template&id=ba4436c2&scoped=true&"
import script from "./TradingCompetition.vue?vue&type=script&lang=js&"
export * from "./TradingCompetition.vue?vue&type=script&lang=js&"
import style0 from "./TradingCompetition.vue?vue&type=style&index=0&id=ba4436c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4436c2",
  null
  
)

export default component.exports